<template>
  <div v-html="content">
  </div>
</template>

<script setup>
const props=defineProps({
    content:String
})
</script>
